import { t } from "i18next";
import GenericButton from "widgets/controls/buttons/generic";
import GenericDialog from "./generic";

type NotificationDialogProps = {
  isOpen: boolean;
  header: string;
  message: string;
  onClose?: () => void;
  onCancel?: () => void;
  onOk?: () => void;
  okText?: string;
  cancelText?: string;
};

const NotificationDialog = (props: NotificationDialogProps) => {
  const {
    isOpen,
    header,
    message,
    onClose,
    onCancel,
    onOk,
    okText,
    cancelText,
  } = props;

  return (
    <GenericDialog isOpen={isOpen} title={header} onExit={onClose} size="sm">
      <div className="text-secondary">{message}</div>

      <div className="flex gap-2 pt-6">
        {onCancel && (
          <GenericButton
            text={cancelText || t("button.action.cancel")}
            variant="ghost"
            size="md"
            extra="w-full"
            onClick={() => onCancel?.()}
          />
        )}
        {onOk && (
          <GenericButton
            text={okText || t("button.action.ok")}
            size="md"
            extra="w-full"
            onClick={() => onOk?.()}
          />
        )}
      </div>
      {!onCancel && !onOk && (
        <div className="flex flex-grow justify-end">
          <GenericButton
            text={t("button.action.ok")}
            size="md"
            extra="w-[100px]"
            onClick={() => onClose?.()}
          />
        </div>
      )}
    </GenericDialog>
  );
};

export default NotificationDialog;
